import QueryString from 'query-string';
import { push } from 'react-router-redux';
import { toastr } from 'react-redux-toastr';
import {
  DEFAULT_DELETE_CONFIG,
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_BUS_MAINTENANCE_STAY,
  CLEAR_BUSSES_MAINTENANCE_STAY,
  FLAG_BUS_MAINTENANCE_STAY,
  FLAG_GETTING_BUSSES_MAINTENANCE_STAY,
  GET_BUS_MAINTENANCE_STAY,
  GET_BUSSES_MAINTENANCE_STAY,
} from '../types';
import { BUS_MAINTENANCE_STAY_ENDPOINT } from '../../config/endpoints';
import { BUS_MAINTENANCE_STAY_PATH } from '../../config/paths';

const flagBussesMaintenanceStay = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_BUSSES_MAINTENANCE_STAY,
    payload: flag,
  });

const getBussesMaintenanceStay = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagBussesMaintenanceStay(true));
    const query = tableFilters;
    const url = `${BUS_MAINTENANCE_STAY_ENDPOINT}?${QueryString.stringify(
      query,
    )}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise);
    const response = await promise.json();
    dispatch({
      type: GET_BUSSES_MAINTENANCE_STAY,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagBussesMaintenanceStay(false));
  }
};

const clearBussesMaintenanceStay = () => (dispatch) =>
  dispatch({
    type: CLEAR_BUSSES_MAINTENANCE_STAY,
  });

const flagBusMaintenanceStayActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_BUS_MAINTENANCE_STAY,
    payload: flag,
  });

const getBusMaintenanceStay =
  async ({ busMaintenanceStayId }) =>
  async (dispatch) => {
    try {
      dispatch(flagBusMaintenanceStayActivity(true));
      const url = `${BUS_MAINTENANCE_STAY_ENDPOINT}/${busMaintenanceStayId}`;
      const promise = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(promise);
      const response = await promise.json();
      dispatch({
        type: GET_BUS_MAINTENANCE_STAY,
        payload: response,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBusMaintenanceStayActivity(false));
    }
  };

const clearBusMaintenanceStay = () => (dispatch) =>
  dispatch({
    type: CLEAR_BUS_MAINTENANCE_STAY,
  });

const postBusMaintenanceStay =
  async ({ registeredBusId, originCityId, estimatedArrivalDate }) =>
  async (dispatch) => {
    try {
      dispatch(flagBusMaintenanceStayActivity(true));
      const payload = {
        registeredBusId,
        originCityId,
        estimatedArrivalDate,
      };
      const url = BUS_MAINTENANCE_STAY_ENDPOINT;
      const promise = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise);
      const busMaintenanceStay = await promise.json();
      if (busMaintenanceStay) {
        dispatch(push(`${BUS_MAINTENANCE_STAY_PATH}/${busMaintenanceStay.id}`));
      }
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBusMaintenanceStayActivity(false));
    }
  };

const putBusMaintenanceStay =
  async (
    busMaintenanceStayId,
    {
      registeredBusId,
      originCityId,
      maintenanceStayStatus,
      estimatedArrivalDate,
      estimatedCompletionDate,
      observation,
    },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagBusMaintenanceStayActivity(true));
      const payload = {
        id: busMaintenanceStayId,
        registeredBusId,
        originCityId,
        maintenanceStayStatus,
        estimatedArrivalDate,
        estimatedCompletionDate,
        observation,
      };
      const url = `${BUS_MAINTENANCE_STAY_ENDPOINT}/${busMaintenanceStayId}`;
      const promise = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(`${BUS_MAINTENANCE_STAY_PATH}/${busMaintenanceStayId}`));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBusMaintenanceStayActivity(false));
    }
  };

const deleteBusMaintenanceStay =
  async ({ busMaintenanceStayId }) =>
  async (dispatch) => {
    try {
      dispatch(flagBusMaintenanceStayActivity(true));
      const url = `${BUS_MAINTENANCE_STAY_ENDPOINT}/${busMaintenanceStayId}`;
      const promise = await fetch(url, {
        ...DEFAULT_DELETE_CONFIG,
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(BUS_MAINTENANCE_STAY_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBusMaintenanceStayActivity(false));
    }
  };

export {
  getBusMaintenanceStay,
  clearBusMaintenanceStay,
  postBusMaintenanceStay,
  putBusMaintenanceStay,
  clearBussesMaintenanceStay,
  getBussesMaintenanceStay,
  deleteBusMaintenanceStay,
};
